import { useState, useEffect } from 'react';
import { PanelGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

import BrButton from '@components/BrButton';
import BrSearchBox from '@components/BrSearchBox';
import ColorStyles from '@components/ColorStyles';
import FilterSectionAccordian from './FilterSectionAccordian';

const DropDownSection = (props) => {
  const { isDataLoading, unifiedFilterState, applyUnifiedFilter, setIsOpen } = props;
  const [filterState, setFilterState] = useState(unifiedFilterState);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeKey, setActiveKey] = useState('');

  useEffect(() => {
    setFilterState(props.unifiedFilterState);
  }, [props.unifiedFilterState]);

  const checkBoxChangeHandler = (key, value) => {
    const newFilterState = JSON.parse(JSON.stringify(filterState));
    // eslint-disable-next-line eqeqeq
    const filtersForThisColumn = newFilterState.allFilters.find((entry) => entry.key == key).filters;
    // eslint-disable-next-line eqeqeq
    const filterToToggle = filtersForThisColumn.find((entry) => entry.value == value);
    filterToToggle.selected = !filterToToggle.selected;

    setFilterState(newFilterState);
  };

  const clearAllFilters = () => {
    const newFilterState = {};
    newFilterState.allFilters = [];
    unifiedFilterState.allFilters.forEach((filterByKey) => {
      const newFilterByKey = { ...filterByKey };
      newFilterByKey.filters = [...filterByKey.filters];
      newFilterByKey.filters.forEach((entry) => { entry.selected = false; });
      newFilterState.allFilters.push(newFilterByKey);
    });
    setFilterState(newFilterState);
    applyUnifiedFilter(newFilterState);
  };

  const getColumnFilterSection = (colFilter) => {
    return (
      <FilterSectionAccordian
        checkBoxChangeHandler={checkBoxChangeHandler}
        colFilter={colFilter}
        activeKey={activeKey}
        searchQuery={searchQuery}
        key={colFilter.key}
      />
    );
  };

  const applyHandler = () => {
    applyUnifiedFilter(filterState);
    setIsOpen(false);
  };
  const handleAccordianSelect = (activeKey) => {
    setActiveKey(activeKey);
  };
  const queryChangeHandler = (query) => {
    setSearchQuery(query);
  };
  return isDataLoading ? null : (
    <div className="unified-filter-dropdown-section">
      <div className="header">
        <BrSearchBox
          query={searchQuery}
          onQueryChange={queryChangeHandler}
          onQuerySubmit={queryChangeHandler}
          placeholder="Search"
        />
      </div>
      <div className="body">
        <PanelGroup accordion id="filters" activeKey={activeKey} onSelect={handleAccordianSelect}>
          {filterState.allFilters.map((colFilter) => getColumnFilterSection(colFilter))}
        </PanelGroup>
      </div>
      <div className="footer">
        <BrButton onClick={() => clearAllFilters()} title="Clear" />
        <BrButton onClick={applyHandler} title="Apply" colorStyle={ColorStyles.BGBLUE} />
      </div>
    </div>
  );
};

DropDownSection.propTypes = {
  unifiedFilterState: PropTypes.object,
  applyUnifiedFilter: PropTypes.func,
  isDataLoading: PropTypes.bool,
};

export default DropDownSection;
